let isKeyboardNavigation = false;

$(function () {
  let windowWidth = $(window).innerWidth();

  $(window).resize(function () {
    windowWidth = $(window).innerWidth();
    switchIconForIeMobile();
    if (windowWidth <= 1365) {
      if ($('.sidebar').hasClass('open') || $('.navOverlay').css('display') !== 'none') {
        $('.sidebarButtonIcon.close').show();
        $('.sidebarButtonIcon.open').hide();
      } else {
        $('.sidebarButtonIcon.close').hide();
        $('.sidebarButtonIcon.open').show();
      }
      if ($('.navOverlay').css('display') !== 'none') {
        $('.goBackToFirstLevel').show();
      }
    } else {
      if ($('.childrenColumns.backToHere').css('display') === 'none') {
        $('.childrenColumns.backToHere').show();
      }
    }
    if (windowWidth <= 1365) {
      if ($('.upper > .firstLevel.backToHere').css('display') !== 'none') {
        $('.upper > .firstLevel.backToHere').css('display', 'none');
      }
      if ($('.upper > .secondLevel:not(:empty)').length > 0) {
        $('.subnav.active .upper > .secondLevel:not(:empty)')
          .parent()
          .find('.firstLevel')
          .addClass('backToHere');
        $('.subnav.active .upper > .secondLevel:not(:empty)')
          .parent()
          .find('.firstLevel.backToHere')
          .css('display', 'none');
      }
    }
  });

  // Keyboard handlers
  $(document).on('mousedown', function (e) {
    isKeyboardNavigation = false;
    cleanInert();
  });

  $(document).on('keydown', function (e) {
    isKeyboardNavigation = true;

    const $overlay = $('.navOverlay');

    // Trap focus inside the navOverlay when visible
    if ($overlay.is(':visible')) {
      const focusableElements = getFocusableElements($overlay); // Get all focusable elements in the overlay
      const firstFocusableElement = focusableElements.first();
      const lastFocusableElement = focusableElements.last();

      // Handle the Tab key to trap focus
      if (e.key === 'Tab') {
        // Shift+Tab: move focus backward
        if (e.shiftKey) {
          if (document.activeElement === firstFocusableElement[0]) {
            e.preventDefault();
            lastFocusableElement.focus(); // Loop focus to the last element
          }
        }
        // Tab: move focus forward
        else {
          if (document.activeElement === lastFocusableElement[0]) {
            e.preventDefault();
            firstFocusableElement.focus(); // Loop focus to the first element
          }
        }
      }
    }

    // Handle Escape key for closing secondLevel and refocusing on firstLevel
    if (e.key === 'Escape') {
      const $overlay = $('.navOverlay');
      const $secondLevel = $overlay.find('.upper > .secondLevel');
      const $sidebar = $('.navigation').find('.sidebar');
      const $logo = $('.navigation .logo');
      const isSecondLevelPopulated = $secondLevel.children().length > 0;

      if (isSecondLevelPopulated) {
        // Second level is populated, return focus to the firstLevel and clear the secondLevel
        const $activeFirstLevel = $('.subnav.active .upper > .firstLevel:visible');
        $activeFirstLevel.find('li.active').first().children().first().focus();
        $secondLevel.html(''); // Clear the secondLevel contents

        // handle mobile
        $('.backToHere').show();
        $('.backToHere').removeClass('backToHere');
      }
      // first level open, mobile
      else if ($sidebar.hasClass('open') && !$overlay.is(':visible')) {
        $logo.find('.sidebarButtonIcon.open').show();
        $logo.find('.sidebarButtonIcon.close').hide();
        $sidebar.removeClass('open');
        $sidebar.addClass('closed');
        $sidebar.hide();
      } else {
        // Second level is not populated, close the overlay
        $overlay.fadeOut(150, function () {
          cleanInert();
          focusOnLastActiveSidebarElement();
        });
        $('body').css('overflow-y', 'auto');
        $logo.removeClass('fixed');
        $overlay.find('.active').removeClass('active'); // Clear any active states
      }
    }
  });

  // Sidebar dropdown menu toggle
  $('.sidebar .menu .title .openMenuBtn').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $this = $(this);
    const $title = $this.closest('.title');
    const $menu = $this.closest('.menu');

    if ($menu.hasClass('open')) {
      $menu.removeClass('open');
      $menu.addClass('closed');

      const $sidebar = $('.navigation').find('.sidebar');
      $sidebar.find('.active').removeClass('active');

      $title.attr('aria-expanded', 'false');
      $this.attr('aria-expanded', 'false');
      $menu.find('.content').slideUp(300);
    } else {
      $title.attr('aria-expanded', 'true');
      $this.attr('aria-expanded', 'true');
      $menu.removeClass('closed');
      $menu.addClass('open');
      $menu.find('.content').slideDown(300);
    }
  });

  // Overlay toggle
  $('.toggleOverlayBtn').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $this = $(this);
    const $listElement = $this.closest('li'); //parent li

    if ($this.data('url') !== undefined) {
      if ($this.data('target') === '_blank') {
        window.open($this.data('url'), '_blank');
      } else {
        window.location.replace($this.data('url'));
      }
      return;
    }

    const $subnav = $('.navOverlay .subnav[data-uid="' + $this.data('uid') + '"]');
    const $sidebar = $('.navigation').find('.sidebar');
    const $overlay = $('.navOverlay');
    const $secondLevel = $overlay.find('.upper > .secondLevel');
    const $logo = $('.navigation .logo');

    $secondLevel.html('');

    $overlay.fadeIn(150, function () {
      if (isKeyboardNavigation) {
        setInert();
      }
    });
    $('body').css('overflow-y', 'hidden');
    $logo.addClass('fixed');

    $overlay.find('.active').removeClass('active');
    $subnav.addClass('active');

    $sidebar.find('.active').removeClass('active');
    $listElement.addClass('active');

    // Move focus to the first button or link in the first <li> of .firstLevel
    $subnav.find('.firstLevel > li').first().children().first().focus();

    if ($('.closeOverlayBtn.cross').css('display') == 'none') {
      $overlay.find('.goBackToFirstLevel').show();
    }

    // dynamic column creation on firstLevel
    const $activeSubnav = $('.subnav.active');
    const menuList = $activeSubnav.find('.firstLevel.childrenColumns').children('li');

    let counter = 1;

    for (let i = 1; i < menuList.length; i++) {
      if (
        i % 11 === 0 && // every 11th item
        !$activeSubnav.find(`li[data-emptyItem="${counter}"]`).length // dynamic current empty item
      ) {
        $(menuList[i]).after(
          '<li class="title empty" data-emptyItem="' + counter + '">&#8203;</li>'
        );
        counter++;
      }
    }
  });

  // Close overlay desktop
  $('.navOverlay .closeOverlayBtn').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $overlay = $('.navOverlay');
    const $secondLevel = $overlay.find('.upper > .secondLevel');
    const $logo = $('.navigation .logo');

    $secondLevel.html('');

    $overlay.find('.active').removeClass('active');

    $overlay.fadeOut(150, function () {
      cleanInert();
      focusOnLastActiveSidebarElement();
    });
    $('body').css('overflow-y', 'auto');
    $logo.removeClass('fixed');
  });

  // Populate second level
  $('.navOverlay ul.firstLevel > li:has(ul)').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $this = $(this);
    const $children = $this.find('ul > li');
    const $overlay = $('.navOverlay');
    const $secondLevel = $overlay.find('.upper > .secondLevel');

    $overlay.find('.firstLevel > li.active').removeClass('active');
    $this.addClass('active');

    if ($('.closeOverlayBtn.cross').css('display') == 'none') {
      $this.parent('ul').addClass('backToHere').hide();
      $this.parent().parent().find('.goBackToFirstLevel').show();
    }

    $secondLevel.html('');
    $secondLevel.html(
      '<li class="title"><a href="' + $this.data('link') + '">' + $this.data('title') + '</a></li>'
    );
    $secondLevel.append($children.clone());

    // set focus on link in first <li> of active .secondLevel
    const $activeSecondLevel = $('.subnav.active .upper > .secondLevel');
    $activeSecondLevel.find('li:first-child a:first').focus();
  });

  // Back to first level
  $('.upper .goBackToFirstLevel').on('click', function (e) {
    const $this = $(this);
    const $overlay = $('.navOverlay');
    const $secondLevel = $overlay.find('.upper > .secondLevel');
    const $sidebar = $('.navigation').find('.sidebar');
    const $logo = $('.navigation .logo');

    if ($('.backToHere').length > 0) {
      $('.backToHere').removeClass('backToHere');
      $this.parent().find('ul.firstLevel').show();
      $secondLevel.html('');
    } else {
      $sidebar.find('.active').removeClass('active');
      $sidebar.removeClass('closed');
      $sidebar.addClass('open');
      $logo.find('.sidebarButtonIcon.close').show();
      $logo.find('.sidebarButtonIcon.open').hide();
      $logo.removeClass('fixed');
      $sidebar.show();
      $overlay.fadeOut(150, function () {
        cleanInert();
      });
      $this.hide();
      $('body').css('overflow-y', 'auto');
    }
  });

  // Responsive sidebar toggle
  $('.logo .sidebarButton').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $logo = $('.navigation .logo');
    const $sidebar = $('.navigation').find('.sidebar');
    const $overlay = $('.navOverlay');
    const $activeSubnav = $('.subnav.active');
    const $secondLevel = $overlay.find('.upper > .secondLevel');

    if ($sidebar.hasClass('open')) {
      // If overlay is not active, then we close the menu. Otherwise we close the overlay.
      $sidebar.removeClass('open');
      $sidebar.addClass('closed');
      $logo.find('.sidebarButtonIcon.open').show();
      $logo.find('.sidebarButtonIcon.close').hide();
      $sidebar.hide();
      $('body').css('overflow-y', 'auto');
      $logo.removeClass('fixed');

      $activeSubnav.find('.backToHere').removeClass('backToHere');
      $activeSubnav.find('ul.firstLevel').show();
      $activeSubnav.find('.goBackToFirstLevel').hide();

      $secondLevel.html('');
      $overlay.find('.active').removeClass('active');
      $sidebar.find('.active').removeClass('active');
      $overlay.fadeOut(150, function () {
        cleanInert();
      });
    } else {
      $sidebar.removeClass('closed');
      $sidebar.addClass('open');
      $logo.find('.sidebarButtonIcon.close').show();
      $logo.find('.sidebarButtonIcon.open').hide();
      $sidebar.show();
    }
  });

  switchIconForIeMobile();
});
// helper functions
function switchIconForIeMobile() {
  var windowWidth = $(window).innerWidth();
  if ($('html').hasClass('is--ie')) {
    if (windowWidth < 1366) {
      $('.btn-search')
        .find('img')
        .attr('src', $('.btn-search').find('img').attr('src').replace('_white', ''));
      $('.btn-login')
        .find('img')
        .attr('src', $('.btn-login').find('img').attr('src').replace('_white', ''));
    } else {
      $('.btn-search')
        .find('img')
        .attr(
          'src',
          $('.btn-search')
            .find('img')
            .attr('src')
            .replace(/icon-apobank_piktogramm__lupe\b/, 'icon-apobank_piktogramm__lupe_white')
        );
    }
  }
}

function focusOnLastActiveSidebarElement() {
  // Focus back on the sidebar: find the .menu.open and the active li inside it
  const $activeLi = $('.sidebar').find('li.active');

  if ($activeLi.length > 0) {
    // Focus on the first interactive element inside the active <li>
    $activeLi.children('a, button').first().focus();

    $activeLi.removeClass('active');
  }
}

function getFocusableElements($container) {
  return $container
    .find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])')
    .filter(':visible');
}

function setInert() {
  $('main').attr('inert', 'true');
  $('footer').attr('inert', 'true');
  $('.logo').attr('inert', 'true');
  $('.quickLinks').attr('inert', 'true');
  $('.sidebar').attr('inert', 'true');
}

function cleanInert() {
  $('main').removeAttr('inert');
  $('footer').removeAttr('inert');
  $('.logo').removeAttr('inert');
  $('.quickLinks').removeAttr('inert');
  $('.sidebar').removeAttr('inert');
}
